'use client'

import React from 'react'
import type {CheckboxFilter, SelectFilter} from '../types'
import {CheckBox} from '@/src/shared/ui/inputs/checkbox'

interface FilterCheckboxValuesProps {
  filter: CheckboxFilter | (SelectFilter & {multiple: true})
  onChange: (code: string, values: string[] | undefined) => void
}

export function FilterCheckboxValues({filter, onChange}: FilterCheckboxValuesProps) {
  const [selected, setSelected] = React.useState<string[]>(() =>
    filter.values.filter((v) => v.selected).map((v) => v.value),
  )

  React.useEffect(() => {
    setSelected(filter.values.filter((v) => v.selected).map((v) => v.value))
  }, [filter.values])

  const handleChange = (value: string) => {
    let next = [...selected]
    if (next.includes(value)) {
      next.splice(next.indexOf(value), 1)
    } else {
      next = [...next, value]
    }
    setSelected(next)
    onChange(filter.code, next.length > 0 ? next : undefined)
  }

  return (
    <>
      {filter.values.map((filterValue) => (
        <CheckBox
          id={`checkbox-${filter.code}-${filterValue.title}-${filterValue.value}`}
          checked={selected.includes(filterValue.value)}
          key={`${filterValue.title}-${filterValue.value}`}
          name={filter.code}
          disabled={filterValue.disabled}
          onChange={() => handleChange(filterValue.value)}>
          {filterValue.title}
        </CheckBox>
      ))}
    </>
  )
}
